<template>
  <div class="search_result">
    <div class="search-Input XYcenter">
      <div class="startInput animated fadeIn">
        <orderSearch @quickSearch="quickSearch"></orderSearch>
      </div>
    </div>
    <div class="box paddBott50" id="quickQuery">
      <div class="search_result_line marTop10">
        <div class="flex">
          <div
            class="state_box marRight15 pointer flex color66"
            v-for="(item, index) in stateItem"
            @click="changeState(item.code)"
            :class="{'color26': item.code === stateValue}"
            :key="index">
            <i class="iconfont size16" :class="item.icon"></i>
            <div class="marLeft5">
              <span>{{item.name}}</span>
              <span v-show="item.num" class="colorR">{{'(' + item.num + ')'}}</span>
            </div>
            <span v-show="index !== stateItem.length - 1" class="colorDC marLeft15">|</span>
          </div>
        </div>
        <div>
          <!--查询更多-->
          <!--<el-button @click="queryOpen(true)" size="small" type="primary">{{$t('page.tracking_more')}}</el-button>-->
        </div>
      </div>
      <track-id v-if="typeValue === 'trackId'" @toSroll="autoScrolltoResult()"></track-id>
      <quick-query @getNum="getNum" :stateValue="stateValue" v-if="typeValue === 'quickQuery'" ref="quickQuery" ></quick-query>
    </div>
    <quick-query-alert v-show="queryShow" @close="queryOpen" @quickSearch="quickSearch"></quick-query-alert>
  </div>
</template>

<script>
  import orderSearch from '../components/orderSearch'
  import quickQuery from '../components/new/quickQuery.vue'
  import quickQueryAlert from '../components/new/quickQueryAlert.vue'
  import trackId from '../components/new/trackId.vue'
  import LocalStorage from '@/common/localStorage.js'
  let WOW = require('wowjs');

  export default {
    components: {
      quickQuery,
      quickQueryAlert,
      trackId,
      orderSearch
    },
    data() {
      return {
        queryShow: false,
        typeValue: 'quickQuery',
        stateValue: '',
        stateItem: [
          {
            icon: 'iconquanbu',
            name: this.$t('page.All'),
            code: '',
            num: 0
          }, {
            icon: 'iconchaxunshibai',
            name: this.$t('page.Not_Found'),
            code: 'NotFound',
            num: 0
          }, {
            icon: 'iconyubaofahuo',
            name: this.$t('page.Info_Received'),
            code: 'InfoReceived',
            num: 0
          }, {
            icon: 'iconyunshutuzhong',
            name: this.$t('page.In_Transit'),
            code: 'InTransit',
            num: 0
          }, {
            icon: 'icondaodakequ',
            name: this.$t('page.Pick_Up'),
            code: 'ArrivedDelivery',
            num: 0
          }, {
            icon: 'iconpaisongtuzhong',
            name: this.$t('page.Delivering'),
            code: 'Delivering',
            num: 0
          }, {
            icon: 'iconchenggongpaisong',
            name: this.$t('page.Delivered'),
            code: 'Delivered',
            num: 0
          }, {
            icon: 'icontoudishibai',
            name: this.$t('page.Undelivered'),
            code: 'DeliveryFailure',
            num: 0
          }, {
            icon: 'iconbaoguotuihui',
            name: this.$t('page.Return'),
            code: 'Return',
            num: 0
          }, {
            icon: 'iconkenengyichang',
            name: this.$t('page.Exception'),
            code: 'Exception',
            num: 0
          },
        ],
        query:'',
        paramMap:{},
        nums:'',
        carrierCode:'',
      }
    },
    mounted(){
      new WOW.WOW({live: false, mobile: false}).init()
      if (this.$route.params.aotoSroll ) {
        this.$nextTick(() => {
          this.autoScrolltoResult()
        })
      }
    },
    created() {
      this.query = this.GetQueryString()
      this.typeValue = this.query ? 'trackId' : 'quickQuery'
      let vm = this
      if(window.location.href) {
        let list = {
          items: []
        }
        this.nums = this.utils.getQueryString_('nums')
        this.carrierCode = this.utils.getQueryString_('carrierCode')
        if(vm.nums) {
          let arr = []
          arr = vm.nums.split(',')
          arr.forEach(item=>{
            list.items.push({
              trackingNo: item,
              carrierCode: vm.carrierCode
            })
          })
          vm.quickSearch(list)
        }
      }

    },
    methods: {
      autoScrolltoResult() {//跳转到搜索结果
        document.querySelector('#quickQuery').scrollIntoView({
          behavior: "smooth"
        })
      },
      GetQueryString() {
        let url = window.location.href
        console.log(url,5555555555555)
        if (url.indexOf('?') !== -1) {
          let str = url.substr(1)
          let strs = str.split('=')
          return (strs[1])
        } else {
          return null
        }
      },
      queryOpen(value) {
        this.queryShow = value
      },
      quickSearch(list) {
        this.stateItem.map(function (item) {
          item.num = 0
        })
        this.queryShow = false
        this.$set(this,'typeValue','quickQuery')
        this.stateValue = ''
        this.$nextTick(()=>{
          if(this.$refs.quickQuery) {
            LocalStorage.set('searchList', JSON.stringify(list))
            this.$refs.quickQuery.search(list)
          }
        })
        this.autoScrolltoResult()
      },
      changeState(code) {
        this.stateValue = code
      },
      getNum(list) {
        console.log(list)
        this.stateItem.map(function (item) {
          item.num = 0
          list.map(function (t) {
            if (item.code === t.searchResultCode || item.code === t.trackingStatus) {
              item.num = item.num + 1
            }
          })
        })
      }
    }
  }
</script>

<style scoped>
  .search-Input{
    background: url("../img/cxy.png");
    height: 600px;
    background-size: cover;
  }
  .startInput{
    width: 750px;
    background: white;
    padding: 20px;
    border-radius: 8px;
  }
  .search_result_head {
    height: 80px;
    background-color: #fff;
    -moz-box-shadow: 2px 2px 5px #d2d2d2;
    -webkit-box-shadow: 2px 2px 5px #d2d2d2;
    box-shadow: 2px 2px 5px #d2d2d2;
    display: flex;
    line-height: 80px;
  }

  .search_result_line {
    display: flex;
    justify-content: space-between;
  }

  .logo_i img {
    width: 200px;
    vertical-align: middle;
  }

  .state_box {
    height: 32px;
    line-height: 32px;
  }

  .state_box:hover {
    color: #289EFC;
  }
  .minheight100{
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/page/searchResult.vue